import React from 'react'
import {Pie, Bar,PolarArea} from 'react-chartjs-2'
import {backgroundColor,borderColor} from '../../directories/collections'
const Grafica = ({data,nameAsig,label,title, type}) => {
  if (data === undefined) {
    return null
  }
    const dataBar = {
        labels: nameAsig,
        datasets: [
          {
            label: label,
            data: data,
            backgroundColor,
            borderColor,
            borderWidth: 1,
          },
        ],
      };
      const options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };

    
    const dataLike = {
        labels: nameAsig,
        datasets: [
          {
            label: label,
            data: data,
            backgroundColor,
            borderColor,
            borderWidth: 1,
          },
        ],
      };
    return (
        <>
            <h4 className='txt_title_grafica'>{title}</h4>
            {
                type === 'Polar'
                ? <PolarArea data={dataBar} />
                : type === 'Pie'
                ? <Pie className='bough' data={dataLike} />
                : type === 'Bar'
                && <Bar  data={dataBar} options={options}/>
            }
        </>
    )
}

export default Grafica

